export const BASE_URL = "https://securpoint.app:4000/user/";
// export const BASE_URL = "http://192.168.1.26:5000/user/";
// export const BASE_URL = "http://89.116.21.92:7010/user/";

// Auth :
export const loginAPI = "login";
export const varifyOtpAPI = "verifyOtpMail";
export const forgotPasswordAPI = "forgetPassword";
export const varifyForgotOtpAPI = "verifyForgetPasswordOtp";
export const resetCurrentPasswordAPI = "createPassword";
export const resendOtpAPI = "resendOTP";
export const signUpAPI = "signupByEmail";
export const contactUsAPI = "contactUs";
export const subscriptionsAPI = "myPlans";
export const allPlansAPI = "allPlans";
export const myPlansAPI = "myPlans";
export const purchasePlanAPI = "payment/purchasePlan";
export const stripeButtonStatusAPI = "payment/stripe-button-status";
export const promoteAssetPaymentAPI = "payment/promoteAsset";
export const addDirectPlanAPI = "addPlan/";
export const editProfileAPI = "editProfile";
export const profileAPI = "myProfile";
export const faqAPI = "faqs";
export const policyAPI = "getCms";
export const conditionsAPI = "getCms";

export const allAssetsAPI = "getMyAssets";
export const publicAssetsAPI = "publicHomePage";
export const homeAssetsAPI = "getAllAssets";
export const assetDetailAPI = "publicAsset/";
export const userDetailAPI = "getUser/";
export const reportAssetAPI = "reportAsset";
export const reportUserAPI = "reportUser";
export const markAsMissingAPI = "markAsMissing";
export const editAssetAPI = "editAsset";
export const getCategoriesAPI = "getCategories";
export const getSubCategoriesAPI = "getSubCategories/";
export const assetStatusAPI = "assetStatus";
export const deleteAssetImageAPI = "assetImage/";

// Chat & Message Endpoints (Server root URL without /user/)
export const CHAT_SERVER_URL = BASE_URL.replace(/\/user\/?$/, "");
export const chatsAPI = `${CHAT_SERVER_URL}/chat`;
export const messagesAPI = `${CHAT_SERVER_URL}/message`;

// Notification Endpoints (Server root URL without /user/)
export const notificationsAPI = `${CHAT_SERVER_URL}/notifications`;
export const markAllNotificationReadAPI = `${CHAT_SERVER_URL}/notifications`;
export const markSingleNotificationReadAPI = `${CHAT_SERVER_URL}/notifications/`;
export const deleteAllNotificationsAPI = `${CHAT_SERVER_URL}/notifications/deleteAll`;
export const deleteSingleNotificationAPI = `${CHAT_SERVER_URL}/notifications/`;
